const myExperience = [
    {
        id:1,
        name:"Tech Table",
        type:"internship",
        role:"Full Stack Developer",
        period:"July 2023 - Dec 2023",
        description:"During my tenure at TECH TABLE as a Full Stack Web Developer Intern, I used the MERN stack to develop scalable web solutions. I actively contributed to client projects, ensuring timely delivery of high-quality applications while gaining valuable collaborative experience within the team."
    },
    {
        id:2,
        name:"Novizit",
        type:"internship",
        role:"App Developer",
        period:"August 2023 - present",
        description:"At NOVIZIT, I played a role as a Frontend Developer, focusing on React Native,React.js and Tailwind CSS to create intuitive interfaces for both mobile and web applications. This included aligning development with product design to deliver a Minimum Viable Product (MVP) effectively."
    }
]

export default myExperience;